// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1rWKN","col":"styles_col__3x0O-"};